<template>
  <div>
    <split-view>
      <template #english>
        <blocks v-if="home.english" :content="JSON.parse(home.english)" />
      </template>
      <template #chinese>
        <blocks v-if="home.chinese" :content="JSON.parse(home.chinese)" />
      </template>
    </split-view>
    <section class="articles-list">
      <h1>Articles (文章)</h1>
      <div class="wrapper">
        <router-link
          :to="{ name: 'article', params: { uid: article.uid } }"
          v-for="article in articles"
          :key="article.uid"
        >
          <h2>{{ article.title }}</h2>
          <p class="nm">{{ article.author }} / {{ article.date }}</p>
        </router-link>
      </div>
    </section>
    <section class="database-link pad">
      <router-link :to="{ name: 'database' }"
        ><h1 class="nm">Consult the Database (数据库) &rarr;</h1></router-link
      >
    </section>
  </div>
</template>

<script>
const SplitView = () =>
  import(/* webpackChunkName: "View" */ "@/components/SplitView.vue");
const Blocks = () =>
  import(/* webpackChunkName: "Blocks" */ "@/components/Blocks.vue");
import { mapState } from "vuex";
export default {
  name: "home",
  components: {
    SplitView,
    Blocks,
  },
  metaInfo() {
    return {
      title: this.site.title,
      titleTemplate: null,
    };
  },
  computed: mapState(["site", "home", "articles"]),
};
</script>

<style lang="scss">
.articles-list {
  background: black;
  width: 100%;
  padding-top: var(--lh);
  h1 {
    color: white;
    padding: 0 var(--lh);
  }
  .wrapper {
    display: flex;
    align-items: stretch;
    width: 100%;
    overflow-x: auto;
    padding: var(--lh);
    padding-bottom: calc(2 * var(--lh));
    scroll-snap-type: x mandatory;
    a {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      scroll-snap-align: start;
      width: 40vw;
      padding: 0 var(--lh);
      flex: 0 0 auto;
      color: white;
      p {
        color: var(--hover);
      }
    }
  }
}
.database-link {
  padding-bottom: calc(1.5 * var(--lh));
}
</style>
